import { Alert, Button, Modal } from "react-bootstrap";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import ThemedModal from "../../../@ui/Modal/ThemedModal";

export interface MarkAsResolvedProps {
  orderItemId: string;
  onResolve: (orderItemId: string) => void;
  onClose: () => void;
}

const MarkAsResolved = ({
  orderItemId,
  onResolve,
  onClose,
}: MarkAsResolvedProps) => {
  return (
    <ThemedModal onHide={onClose} centered show={true}>
      <Modal.Header className="bg-secondary text-white" closeButton>
        <StyledModalTitle>Deferred Request Details</StyledModalTitle>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning">
          Are you sure you want to resolve this failed deferred request?
          <br />
          This will remove this failure from the list permanently.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="success"
          onClick={() => {
            onClose();
            onResolve(orderItemId);
          }}>
          Resolve
        </Button>
        <Button variant="danger" onClick={() => onClose()}>
          Cancel
        </Button>
      </Modal.Footer>
    </ThemedModal>
  );
};

export default MarkAsResolved;
